import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { ChatMode } from 'dragonmouse-shared/interfaces';
import { useDsChatQueue } from 'hooks/useDsChatQueue';
import { useSelector } from 'react-redux';
import { selectActiveDsChat } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';

interface Props {
	label: string;
	prompt: string;
}

const GenerateGalleryAction = ({ label, prompt }: Props) => {
	const dsChat = useSelector((r: RootReducer) => selectActiveDsChat(r.db));
	const queue = useDsChatQueue(dsChat?.id ?? null);
	const clientKey = `gallery:${prompt}`;
	const isQueued = queue.items.some((e) => e.clientKey === clientKey);

	const onClick = () => {
		if (!dsChat || isQueued) return;
		queue.enqueue({
			label,
			clientKey,
			payload: {
				kind: 'addUserEntry',
				entry: {
					kind: 'user',
					message: prompt,
					attachments: [],
					sourceFrameIds: [],
				},
				chatMode: ChatMode.DESIGN_AND_CHAT,
			},
		});
	};

	return (
		<ActionButton
			icon={IconType.LAYOUT}
			label={label}
			isQueued={isQueued}
			prompt={prompt}
			onClick={onClick}
		/>
	);
};

export default GenerateGalleryAction;
